import { render } from "./DepartamentoModal.vue?vue&type=template&id=63cca686&ts=true"
import script from "./DepartamentoModal.vue?vue&type=script&lang=ts"
export * from "./DepartamentoModal.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Desenvolvimento\\NeoXFront\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__